import React from 'react';
import FormEntry from 'controls/react/form/formEntry';
import { AntInput } from 'controls/react/ant/antInput';
import { linkModel, MobxManager, ModelValidator, ValidatableModel } from 'framework/mobx-integration';
import { makeAutoObservable } from 'mobx';
import { Section } from 'controls/react/layout/section';
import { observer } from 'mobx-react';
import { sharedLocalization } from 'vendor-init/tinymce/plugins/localization';
import { ApplicationState } from 'framework/applicationState';
import { AccountSelector } from 'controls/react/accountSelector';
import { AttributesConfig, CustomAttributes } from './attributes';
import { translator } from 'core/localization';
import { DataSourceSelectorPlain } from 'controls/designer/features/widgets/datasources/shared/components/data-source-selector/dataSourceSelector';

const i = translator(sharedLocalization);

export class DatasourceGridConfig implements ValidatableModel<DatasourceGridConfig>, AttributesConfig {
	accountId: string;
	sourceId: string = '';

	attributes = new CustomAttributes();

	validator = new ModelValidator(this);
	mobx = new MobxManager();

	constructor({ newConfig }: { newConfig?: boolean } = {}) {
		this.accountId = ApplicationState.accountId;
		makeAutoObservable(this);

		// temporary solution
		if (newConfig) {
			this.attributes.add('columns', '').add('use-headers', 'true').add('alignment', 'left').add('sort-columns', '');
		}

		this.validator.required('accountId').required('sourceId');
	}

	destroy = () => {
		this.validator.destroy();
		this.mobx.destroy();
	};
}

const DatasourceGridForm = observer((props: { config: DatasourceGridConfig }) => {
	return (
		<Section childrenPadding={true} appearance={'none'}>
			<FormEntry label={i('Account')} model={props.config} modelField={'accountId'}>
				<AccountSelector />
			</FormEntry>
			<FormEntry label={i('Source')} model={props.config} modelField={'sourceId'}>
				<DataSourceSelectorPlain accountId={props.config.accountId} />
			</FormEntry>
		</Section>
	);
});

export const datasourceGridComponentDescription = {
	id: 'ceeview/table',
	type: 'ceeview/table',
	title: i('Datasource grid'),
	config: DatasourceGridConfig,
	form: DatasourceGridForm,
	preview: require('./datasourceGrid.png'),
	defaultSize: {
		width: '300px',
		height: '115px',
	},
};
